import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'sp-tag',

  standalone: false,
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss']

})
export class TagsComponent implements TagInterface {
  @Input() label = 'Button';
  @Input() type = '';
  @Input() style = 'tag-default';
  @Input() link = null;
  @Input() removeable = false;

  @Output() OnClickEvent = new EventEmitter<boolean>();
  @Output() OnRemoveEvent = new EventEmitter<boolean>();

  onClickEvent() {
    this.OnClickEvent.emit();
  }

  onRemoveEvent() {
    this.OnRemoveEvent.emit();
  }

  constructor() {}

  CombineStyle(style = '', tags = '') {
    try {
      style = String(style);
    } catch (e) {}
    try {
      tags = String(tags);
    } catch (e) {}

    return `${style} ${tags}`;
  }
}

export interface TagInterface {
  label?: string;
  type?: string;
  style?: string;
  icon?: string;
  link?: string;
  removeable?: boolean;
  OnClickEvent?: any;
  OnRemoveEvent?: any;
}